import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Icon_GPlus",
  "use": "Icon_GPlus-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol viewBox=\"0 0 42 42\" id=\"Icon_GPlus\">\n<g>\n\t<g>\n\t\t<path d=\"M12.697,19.221l0.014,3.463h8.106c-0.959,4.216-3.917,6.801-7.889,6.801c-5.209,0-9.432-4.245-9.432-9.484\n\t\t\tc0-5.238,4.222-9.483,9.432-9.483c2.477,0,4.729,0.96,6.412,2.531L22,10.742C19.666,8.429,16.463,7,12.928,7\n\t\t\tC5.787,7,0,12.821,0,20c0,7.181,5.787,13,12.928,13c6.856,0,11.812-5.258,11.812-12.438l-0.021-1.341H12.697z M37.036,19.364\n\t\t\tv-4.991h-3.167v4.991h-4.963v3.183h4.963v4.991h3.167v-4.991H42v-3.183H37.036z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Icon_GPlus.svg
// module id = 230
// module chunks = 0